import { useEffect, useState } from 'react';
import { useTranslation } from '../../services/LanguageContext'; // Import useTranslation hook
import './aboutPage.scss';

const AboutPage = () => {
    const { language, t } = useTranslation(); // Get the translation hook
    const [aboutUs, setAboutUs] = useState(null);
    const [loading, setLoading] = useState(true);

    // Fetch About Us data based on selected language
    useEffect(() => {
        const fetchAboutUs = async () => {
            setLoading(true);
            
            try {
                // Convert language to lowercase for the locale parameter
                const locale = language.toLowerCase();
                
                // Add locale parameter to the API URL
                const apiUrl = `https://find-together-api.sslbeta.de/api/Support/getAboutUs?locale=${locale}`;
                
                console.log(`Fetching About Us for locale: ${locale} from ${apiUrl}`);
                
                const response = await fetch(apiUrl);                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const data = await response.json();
                
                // Validate the response data
                if (!Array.isArray(data) || data.length === 0) {
                    throw new Error('Invalid response format: expected a non-empty array');
                }
                
                // Assuming the API returns an array and we take the first item
                setAboutUs(data[0]);
                console.log(`Successfully loaded About Us content for locale: ${locale}`);
                
            } catch (error) {
                console.error('Error fetching About Us:', error);
                // Set fallback About Us content based on language
                const fallbackContent = language === 'DE' ? {
                    title: 'Über Find Together',
                    description: `
                        <p><strong>Find Together</strong> ist eine innovative Dating-App, die darauf abzielt, Menschen dabei zu helfen, ihren perfekten Partner zu finden.</p>
                        <p>Unsere Mission ist es, authentische Verbindungen zwischen Menschen zu schaffen, die wirklich zueinander passen. Mit unserem intelligenten Matching-Algorithmus und verifizierten Profilen bieten wir eine sichere und effektive Plattform für moderne Partnersuche.</p>
                        <p><strong>Warum Find Together?</strong></p>
                        <ul>
                            <li>Intelligente Partnervermittlung basierend auf Kompatibilität</li>
                            <li>Verifizierte Profile für mehr Sicherheit</li>
                            <li>Kostenlose Nutzung mit minimaler Werbung</li>
                            <li>Benutzerfreundliche Oberfläche</li>
                        </ul>
                        <p>Starten Sie noch heute Ihre Reise zur großen Liebe!</p>
                    `,
                    imageUrl: null
                } : {
                    title: 'About Find Together',
                    description: `
                        <p><strong>Find Together</strong> is an innovative dating app designed to help people find their perfect partner.</p>
                        <p>Our mission is to create authentic connections between people who truly match each other. With our intelligent matching algorithm and verified profiles, we provide a safe and effective platform for modern partner search.</p>
                        <p><strong>Why Find Together?</strong></p>
                        <ul>
                            <li>Intelligent matchmaking based on compatibility</li>
                            <li>Verified profiles for enhanced security</li>
                            <li>Free to use with minimal advertising</li>
                            <li>User-friendly interface</li>
                        </ul>
                        <p>Start your journey to finding love today!</p>
                    `,
                    imageUrl: null
                };
                
                setAboutUs(fallbackContent);
            } finally {
                setLoading(false);
            }
        };

        fetchAboutUs();
    }, [language]); // Refetch when language changes

     return (        
     <div className='container inner-page-container'>
            
            {!loading && aboutUs && (
                <div className='about-us-content'>
                    {aboutUs.imageUrl && (
                        <div
                            className='cover-image mb-4'
                            style={{ 
                                backgroundImage: `url(${aboutUs.imageUrl})`,
                                height: '300px',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                borderRadius: '8px'
                            }}
                        />
                    )}
                    
                    <h2 className='text-left my-5'>{aboutUs.title}</h2>
                    
                    {/* Render HTML description */}
                    <div
                        className="about-description"
                        dangerouslySetInnerHTML={{ __html: aboutUs.description }}
                    />
                    
                    {/* Additional metadata if available */}
                    {aboutUs.lastUpdated && (
                        <div className="mt-4 text-muted small">
                            <em>Zuletzt aktualisiert: {new Date(aboutUs.lastUpdated).toLocaleDateString('de-DE')}</em>
                        </div>
                    )}
                </div>
            )}
            
            {!loading && !aboutUs && (
                <div className='alert alert-info text-center' role="alert">
                    <h4>ℹ️ Keine Inhalte verfügbar</h4>
                    <p className="mb-0">Die Über uns-Seite ist momentan nicht verfügbar. Bitte versuchen Sie es später erneut.</p>
                </div>
            )}
        </div>
    );
};

export default AboutPage;
